import React from "react";
import { motion } from "framer-motion";

const contact = () => {
  return (
    <motion.div
      exit={{ opacity: 0, x: "-100vw", transition: "easeInOut" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <section className="section single-page">
        <div className="section-title">
          <h2>Contact</h2>
          <div className="underline"></div>
        </div>
        <div className="section-center page-info">
          <p>
            If you are looking to get ahold of me, you can send me an email at
            <a href="mailto:juni430@gmail.com">: juni430@gmail.com</a>
          </p>

          <p>
            You can also reach me on Linkedin at
            <a href="https://www.linkedin.com">: linkedin.com/in/juac08</a>
          </p>
        </div>
      </section>
    </motion.div>
  );
};

export default contact;
